import { render, staticRenderFns } from "./RecordStampDialog.vue?vue&type=template&id=006b4090"
import script from "./RecordStampDialog.vue?vue&type=script&lang=ts"
export * from "./RecordStampDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports